import { createContext } from 'react';

export interface Coords {
    lat?: number;
    lng?: number;
}

export interface CountryContextType {
    country: string;
    coords: Coords;
    dialCode: string;
    sellerAvailableCountries: string[];
    agentAvailableCountries: string[];
    loading: boolean;
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export default CountryContext;
